<template>
    <div>
        <p class="text-gray-500 text-sm mb-4">Heute maximal {{ Math.floor(maxBookingMinutes / 60) }} Stunden verfügbar, bis höchstens {{ new Date().getHours() + maxBookingMinutes/60}}:00 Uhr</p>

        <div v-show="!isCustomMinutes">
            <div class="grid grid-cols-4 gap-8 w-full">
                <div v-for="hour in times" :key="hour">
                    <button-primary class="w-full" @click="$emit('selected', hour * 60)">
                        {{ hour }} Stunde{{ hour > 1 ? 'n' : '' }}
                    </button-primary>
                </div>
                <button-primary class="w-full" @click="isCustomMinutes = true">
                    Eigene Zeit
                </button-primary>
            </div>
        </div>

        <div v-show="isCustomMinutes">
            <input
                class="w-full"
                type="range" min="60"
                :max="maxBookingMinutes" step="60" v-model="bookingMinutes"><br>

            {{ (bookingMinutes / 60) }} Stunden, bis {{ new Date().getHours() + Math.floor(bookingMinutes/60) }}:{{ bookingMinutes%60 ? '30' : '00' }} Uhr.<br>

            <div class="flex justify-end mt-4">
                <button-primary @click="$emit('selected', bookingMinutes)">
                    Buchen
                </button-primary>
            </div>
        </div>

    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary.vue";

export default {
    name: "TimePicker",

    components: {ButtonPrimary},

    data: () => ({
        bookingMinutes: 60,
        isCustomMinutes: false,
    }),

    computed: {
        times() {
            let times = [1, 2, 4, 6, 8, 10, 12];

            times.filter(time => time <= this.maxBookingMinutes / 60);

            return times;
        }
    },

    props: ['maxBookingMinutes'],
}
</script>

<style scoped>

</style>